import { render, staticRenderFns } from "./SurveyPaperDetailView.vue?vue&type=template&id=1d9d07e1&scoped=true"
import script from "./SurveyPaperDetailView.vue?vue&type=script&lang=js"
export * from "./SurveyPaperDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d07e1",
  null
  
)

export default component.exports